import React from "react";
import { StepShell } from "@/components/StepShell";
import { Textarea } from "@/components/ui/textarea";
import { Label } from "@/components/ui/label";
import { RadioGroup, RadioGroupItem } from "@/components/ui/radio-group";
import { REDGREEN_OPTIONS } from "@/lib/screeningData";
import { useI18n } from "@/i18n";
import { Blend } from "lucide-react";

export const RedGreenTest = ({ data, update }) => {
  const { t } = useI18n();
  const r = data.redGreen;
  return (
    <StepShell icon={Blend} title={t("rg_title")} subtitle={t("rg_sub")} testId="redgreen-step">
      <div className="rounded-xl border border-slate-200 bg-white overflow-hidden">
        <div className="grid grid-cols-2 h-64 sm:h-80">
          <div className="flex flex-col items-center justify-center gap-4" style={{ backgroundColor: "#FF0000" }}>
            <span className="optotype text-black" style={{ fontSize: "64px" }}>O X</span>
            <span className="optotype text-black" style={{ fontSize: "40px" }}>C E D</span>
          </div>
          <div className="flex flex-col items-center justify-center gap-4" style={{ backgroundColor: "#00A000" }}>
            <span className="optotype text-black" style={{ fontSize: "64px" }}>O X</span>
            <span className="optotype text-black" style={{ fontSize: "40px" }}>C E D</span>
          </div>
        </div>
        <div className="border-t border-slate-200 bg-slate-50 p-6">
          <Label className="text-xs font-semibold uppercase tracking-wider text-slate-500">{t("rg_question")}</Label>
          <RadioGroup className="mt-3 space-y-2" value={r.result} onValueChange={(v) => update("redGreen", { result: v })}>
            {REDGREEN_OPTIONS.map((o) => (
              <label key={o.value} htmlFor={`rg-${o.value}`}
                className={`flex items-center gap-3 rounded-md border p-4 cursor-pointer transition-colors ${
                  r.result === o.value ? "border-primary bg-primary/5" : "border-slate-200 bg-white hover:bg-slate-50"
                }`}>
                <RadioGroupItem value={o.value} id={`rg-${o.value}`} data-testid={`redgreen-${o.value}`} />
                <span className="text-sm font-medium text-slate-700">{t("rg_o_" + o.value)}</span>
              </label>
            ))}
          </RadioGroup>
          <div className="mt-4 space-y-1.5">
            <Label className="text-xs font-semibold uppercase tracking-wider text-slate-500">{t("notes")}</Label>
            <Textarea data-testid="redgreen-note-input" rows={2} value={r.note}
              onChange={(e) => update("redGreen", { note: e.target.value })} placeholder={t("notes_ph")} />
          </div>
          <p className="mt-4 text-xs text-slate-400 leading-relaxed">{t("rg_note_clinical")}</p>
        </div>
      </div>
    </StepShell>
  );
};
